<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card v-else min-width="350">
        <template v-if="payment.account.logo">
          <v-card-title class="py-4 text-center">
            <v-spacer />
            <v-sheet rounded outlined>
              <v-responsive class="align-center" :aspect-ratio="1/1">
                <v-sheet class="px-1" width="100">
                  <v-img :src="payment.account.logo" width="100%" />
                </v-sheet>
              </v-responsive>
            </v-sheet>
            <v-spacer />
          </v-card-title>
          <v-divider />
        </template>
        <v-card-subtitle>
          <v-toolbar class="mx-n2" color="transparent" flat height="18">
            <v-toolbar-items>
              <v-btn @click="$router.push({ name: 'PaymentRetrieve' })" :disabled="loaderPay" text color="primary"><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-toolbar-items>
            <v-toolbar-title class="pl-4">
              <span class="body-1 text--secondary font-weight-medium">{{payment.balance | currency(payment.currency)}} {{payment.currency}}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="background">
          <v-row no-gutters align="center" justify="start">
            <v-col cols="12" class="py-1">
              <v-sheet class="px-2 py-3" outlined rounded>
                <span class="ml-1 font-weight-medium">Card holder</span>
                <v-text-field v-model="$v.fields.cardHolder.$model" :error="$v.fields.cardHolder.$error" background-color="white" outlined required single-line dense maxlength="80" hide-details />
                <div id="card-element"></div>
                <span class="d-block ml-1 my-2 red--text" v-if="gatewayError"><v-icon color="red" left small>mdi-alert</v-icon>{{gatewayError}}</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 background">
          <v-row align="center" justify="start">
            <v-col cols="12">
              <v-btn @click="pay" :style="{'background-color': `${payment.account.color_background} !important`}" :loading="loaderPay" height="40" block dark>Pagar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'
import cloneDeep from 'lodash/cloneDeep'
import GatewayViewMixin from '@/mixins/GatewayViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import TwoCheckoutMixin from '@/mixins/TwoCheckoutMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  name: 'piriod-gateway-twocheckout',
  inject: ['theme'],
  components: {
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GatewayViewMixin,
    GenericViewMixin,
    TwoCheckoutMixin
  ],
  data: () => ({
    card: null,
    client: null,
    fields: {
      cardHolder: ''
    },
    gatewayError: '',
    loaderPay: false
  }),
  computed: mapState({
    payment: state => cloneDeep(state.payments.payDetail),
    source: state => cloneDeep(state.payments.sourcesDetail),
    paymentsDetail: state => state.payments.paymentsDetail
  }),
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .then(() => {
      if (this.payment.status === 'succeeded' || !this.payment.gateways.includes('twocheckout')) {
        this.$router.push({ name: 'PaymentRetrieve' })
      }
      this.client = new window.TwoPayClient(this.payment.merchants.twocheckout)
      this.card = this.client.components.create('card', this.twocheckoutStyles)
      this.card.mount('#card-element')
    })
  },
  methods: {
    async pay () {
      this.$v.fields.$touch()
      if (this.$v.fields.$invalid) {
        return false
      }
      try {
        this.loaderPay = true
        const tokenizer = await this.client.tokens.generate(this.card, {
          name: this.fields.cardHolder
        })
        await this.createSource('twocheckout', { token: tokenizer.token })
        await this.authorizePayment()
        await this.capturePayment()
        this.$router.push({ name: 'PaymentRetrieve' })
      } catch (error) {
        this.gatewayError = error
      } finally {
        this.loaderPay = false
      }
    }
  },
  validations: {
    fields: {
      cardHolder: {
        required,
        maxLength: maxLength(80)
      }
    }
  }
}
</script>